/**
 * @generated SignedSource<<7c46b36232802dc746960e92f9c26c97>>
 * @relayHash e7986e43df53d92e7848141e8170ba45
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c35f3e250551153c070e50e076ad0a2921f5bb39383ff372c6a1bda58fda9a0b

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type mainUpdateWorkItemAllFieldTypesActionQuery$variables = {
  cloudId: string;
  fieldIdsOrAliases: ReadonlyArray<string>;
  jql: string;
  sprintAris: ReadonlyArray<string>;
};
export type mainUpdateWorkItemAllFieldTypesActionQuery$data = {
  readonly jira: {
    readonly issueSearch: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly fieldsByIdOrAlias: ReadonlyArray<{
            readonly fieldId: string;
            readonly type: string;
          } | null> | null;
          readonly id: string;
          readonly key: string;
          readonly " $fragmentSpreads": FragmentRefs<"actionCard_updateWorkItemAllFieldTypesActionRenderer">;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};
export type mainUpdateWorkItemAllFieldTypesActionQuery = {
  response: mainUpdateWorkItemAllFieldTypesActionQuery$data;
  variables: mainUpdateWorkItemAllFieldTypesActionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldIdsOrAliases"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jql"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sprintAris"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "jql",
        "variableName": "jql"
      }
    ],
    "kind": "ObjectValue",
    "name": "issueSearchInput"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "key"
},
v7 = [
  {
    "kind": "Variable",
    "name": "idsOrAliases",
    "variableName": "fieldIdsOrAliases"
  },
  {
    "kind": "Literal",
    "name": "ignoreMissingFields",
    "value": true
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v9 = {
  "kind": "ScalarField",
  "name": "type"
},
v10 = {
  "kind": "ScalarField",
  "name": "text"
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v13 = [
  (v12/*: any*/),
  {
    "kind": "ScalarField",
    "name": "accountId"
  },
  (v11/*: any*/),
  (v5/*: any*/)
],
v14 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 10
      }
    ],
    "concreteType": "JiraUserConnection",
    "kind": "LinkedField",
    "name": "selectedUsersConnection",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraUserEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": (v13/*: any*/)
          }
        ]
      }
    ],
    "storageKey": "selectedUsersConnection(first:10)"
  }
],
v15 = [
  (v11/*: any*/),
  (v5/*: any*/)
],
v16 = [
  {
    "kind": "ScalarField",
    "name": "timeInSeconds"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainUpdateWorkItemAllFieldTypesActionQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "issueSearch",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "fieldIdsOrAliases",
                            "variableName": "fieldIdsOrAliases"
                          },
                          {
                            "kind": "Variable",
                            "name": "sprintAris",
                            "variableName": "sprintAris"
                          }
                        ],
                        "kind": "FragmentSpread",
                        "name": "actionCard_updateWorkItemAllFieldTypesActionRenderer"
                      },
                      {
                        "args": (v7/*: any*/),
                        "kind": "LinkedField",
                        "name": "fieldsByIdOrAlias",
                        "plural": true,
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "mainUpdateWorkItemAllFieldTypesActionQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "issueSearch",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "concreteType": "JiraSingleLineTextField",
                        "kind": "LinkedField",
                        "name": "summaryField",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueType",
                            "kind": "LinkedField",
                            "name": "issueType",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "small"
                                  }
                                ]
                              },
                              (v5/*: any*/)
                            ]
                          },
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "webUrl"
                      },
                      {
                        "args": (v7/*: any*/),
                        "kind": "LinkedField",
                        "name": "fieldsByIdOrAlias",
                        "plural": true,
                        "selections": [
                          (v12/*: any*/),
                          (v5/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isJiraIssueField"
                          },
                          (v11/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/)
                            ],
                            "type": "JiraSingleLineTextField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraRichText",
                                "kind": "LinkedField",
                                "name": "richText",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraADF",
                                    "kind": "LinkedField",
                                    "name": "adfValue",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraAdfToConvertedPlainText",
                                        "kind": "LinkedField",
                                        "name": "convertedPlainText",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "plainText"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "isTruncated"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "JiraRichTextField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": (v13/*: any*/)
                              }
                            ],
                            "type": "JiraSingleSelectUserPickerField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v14/*: any*/),
                            "type": "JiraPeopleField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v14/*: any*/),
                            "type": "JiraMultipleSelectUserPickerField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": (v15/*: any*/)
                              },
                              {
                                "concreteType": "JiraTransitionConnection",
                                "kind": "LinkedField",
                                "name": "transitions",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraTransitionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraTransition",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "transitionId"
                                          },
                                          {
                                            "concreteType": "JiraStatus",
                                            "kind": "LinkedField",
                                            "name": "to",
                                            "plural": false,
                                            "selections": (v15/*: any*/)
                                          },
                                          (v5/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "JiraStatusField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": (v15/*: any*/)
                              }
                            ],
                            "type": "JiraPriorityField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraLabelConnection",
                                "kind": "LinkedField",
                                "name": "selectedLabelsConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraLabelEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraLabel",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v11/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "JiraLabelsField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "parentIssue",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "issueId"
                                  },
                                  (v6/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "summary"
                                  },
                                  (v5/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraParentIssueField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "number"
                              }
                            ],
                            "type": "JiraNumberField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraTimeTrackingSettings",
                                "kind": "LinkedField",
                                "name": "timeTrackingSettings",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "isJiraConfiguredTimeTrackingEnabled"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "workingHoursPerDay"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "workingDaysPerWeek"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "defaultFormat"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "defaultUnit"
                                  }
                                ]
                              },
                              {
                                "concreteType": "JiraEstimate",
                                "kind": "LinkedField",
                                "name": "originalEstimate",
                                "plural": false,
                                "selections": (v16/*: any*/)
                              },
                              {
                                "concreteType": "JiraEstimate",
                                "kind": "LinkedField",
                                "name": "remainingEstimate",
                                "plural": false,
                                "selections": (v16/*: any*/)
                              },
                              {
                                "concreteType": "JiraEstimate",
                                "kind": "LinkedField",
                                "name": "timeSpent",
                                "plural": false,
                                "selections": (v16/*: any*/)
                              }
                            ],
                            "type": "JiraTimeTrackingField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "color",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "colorKey"
                                  },
                                  (v5/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraColorField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraTeamView",
                                "kind": "LinkedField",
                                "name": "selectedTeam",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "jiraSuppliedName"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraTeamViewField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraSprintConnection",
                                "kind": "LinkedField",
                                "name": "selectedSprintsConnection",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraSprintEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraSprint",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v15/*: any*/)
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "args": [
                                  {
                                    "fields": [
                                      {
                                        "kind": "Literal",
                                        "name": "operation",
                                        "value": "ALLOW"
                                      },
                                      {
                                        "kind": "Variable",
                                        "name": "optionIds",
                                        "variableName": "sprintAris"
                                      }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "filterById"
                                  }
                                ],
                                "concreteType": "JiraSprintConnection",
                                "kind": "LinkedField",
                                "name": "sprints",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraSprintEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraSprint",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "sprintId"
                                          },
                                          (v11/*: any*/),
                                          (v5/*: any*/)
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "type": "JiraSprintField"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c35f3e250551153c070e50e076ad0a2921f5bb39383ff372c6a1bda58fda9a0b",
    "metadata": {},
    "name": "mainUpdateWorkItemAllFieldTypesActionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "447efb1142d55cfb7d9216e207e922af";

export default node;
